// extracted by mini-css-extract-plugin
export default {"sticker":"style_sticker__bERoG"};